// extracted by mini-css-extract-plugin
export default {"item":"LootboxRewardItemCard_item","crew":"LootboxRewardItemCard_crew"};